import { render, staticRenderFns } from "./BaseTablePaginationMini.vue?vue&type=template&id=aac7e1d6&scoped=true&"
import script from "./BaseTablePaginationMini.vue?vue&type=script&lang=js&"
export * from "./BaseTablePaginationMini.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aac7e1d6",
  null
  
)

export default component.exports